import { DSLoadingIndicator } from '@elliemae/ds-loading-indicator';
import { DSCircularIndeterminateIndicator } from '@elliemae/ds-circular-progress-indicator';
import { useAppStore } from '../../store';

const FullScreenSpinner = () => {
  const isFullScreenLoadingSpinnerVisible = useAppStore(
    (state) => state.isFullScreenLoadingSpinnerVisible,
  );

  const fullScreenLoadingSpinnerText = useAppStore(
    (state) => state.fullScreenLoadingSpinnerText,
  );

  return (
    <DSLoadingIndicator
      loading={isFullScreenLoadingSpinnerVisible}
      size="l"
      spinner={
        <DSCircularIndeterminateIndicator
          text={fullScreenLoadingSpinnerText}
          size="l"
          color="light"
        />
      }
    />
  );
};

export default FullScreenSpinner;
